/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ClickIdsFromJSON, ClickIdsToJSON } from './ClickIds';
/**
 * Check if a given object implements the ClaimAttributionResponse interface.
 */
export function instanceOfClaimAttributionResponse(value) {
    if (!('attributionMethod' in value) || value['attributionMethod'] === undefined)
        return false;
    if (!('capturedAt' in value) || value['capturedAt'] === undefined)
        return false;
    if (!('clickIds' in value) || value['clickIds'] === undefined)
        return false;
    if (!('confidence' in value) || value['confidence'] === undefined)
        return false;
    if (!('source' in value) || value['source'] === undefined)
        return false;
    return true;
}
export function ClaimAttributionResponseFromJSON(json) {
    return ClaimAttributionResponseFromJSONTyped(json, false);
}
export function ClaimAttributionResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'attributionMethod': json['attribution_method'],
        'capturedAt': (new Date(json['captured_at'])),
        'clickIds': ClickIdsFromJSON(json['click_ids']),
        'confidence': json['confidence'],
        'firstVisitAt': json['first_visit_at'] == null ? undefined : (new Date(json['first_visit_at'])),
        'landingUrl': json['landing_url'] == null ? undefined : json['landing_url'],
        'source': json['source'],
        'utmCampaign': json['utm_campaign'] == null ? undefined : json['utm_campaign'],
        'utmContent': json['utm_content'] == null ? undefined : json['utm_content'],
        'utmMedium': json['utm_medium'] == null ? undefined : json['utm_medium'],
        'utmSource': json['utm_source'] == null ? undefined : json['utm_source'],
        'utmTerm': json['utm_term'] == null ? undefined : json['utm_term'],
        'visitToken': json['visit_token'] == null ? undefined : json['visit_token'],
    };
}
export function ClaimAttributionResponseToJSON(json) {
    return ClaimAttributionResponseToJSONTyped(json, false);
}
export function ClaimAttributionResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'attribution_method': value['attributionMethod'],
        'captured_at': value['capturedAt'].toISOString(),
        'click_ids': ClickIdsToJSON(value['clickIds']),
        'confidence': value['confidence'],
        'first_visit_at': value['firstVisitAt'] == null ? value['firstVisitAt'] : value['firstVisitAt'].toISOString(),
        'landing_url': value['landingUrl'],
        'source': value['source'],
        'utm_campaign': value['utmCampaign'],
        'utm_content': value['utmContent'],
        'utm_medium': value['utmMedium'],
        'utm_source': value['utmSource'],
        'utm_term': value['utmTerm'],
        'visit_token': value['visitToken'],
    };
}
